// extracted by mini-css-extract-plugin
export var closeButton = "_40-3";
export var header = "_40-0";
export var link = "_40-1";
export var retryButton = "_40-2";